import { Flex, StyleSystemProps, styled } from '@withjoy/joykit';

export const Wrapper = styled(Flex)``;
const wrapperStyles: StyleSystemProps = {
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'flex-end',
};

export const Container = styled(Flex)``;
const containerStyles: StyleSystemProps = {
  flexDirection: 'column',
  backgroundColor: 'mono2',
  padding: 6,
  rowGap: 6,
};

export const styles = {
  wrapper: wrapperStyles,
  container: containerStyles,
};
